import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const personalMedicalQuestionnaire: AnswerPathTreeNode = {
  path: 'personalMedicalQuestionnaire',
  nodeId: NodeIds.personalMedicalQuestionnaire,
};
